import axiosHelper from '@/helpers/axiosHelper';
import ItemPriceMargin from './models/ItemPriceMargin';

const itemsModule = {
	state() {
		return {
			itemPriceMarginMatrix: []
		}
	},
	actions: {
		async fetchPricesMarginMatrixAsync(ctx: any) {
			try {
				const jwt = ctx.getters.jwt;
				const marginMatrixHttpClient = axiosHelper.createInstance(jwt);
				const response = await marginMatrixHttpClient.get('/api/items/marginmatrix');
				if (!response?.data?.length) {
					ctx.commit('setPricesMarginMatrix', []);
					return;
				}
				const matrix = response.data.map((_: any) => new ItemPriceMargin(_));
				ctx.commit('setPricesMarginMatrix', matrix);
			} catch (e) {
				console.error('Error loading items price matrix; no margin will be applied', e);
			}
		}
	},
	mutations: {		
		setPricesMarginMatrix(state: any, payload: Array<ItemPriceMargin>) {
			state.itemPriceMarginMatrix = payload;
		},
	},
	getters: {
		pricesMarginMatrix(state: any) : Array<ItemPriceMargin> {
			return state.itemPriceMarginMatrix;
		},
	}
};

export default itemsModule;